export interface ChatbotMessage {
  text: string;
  sentAt: string;
  isGeneralQuestion?: boolean;
  isUsefulAnswer?: boolean;
  role?: MessageFrom;
  actions?: ChatbotAction[];
}

export enum MessageFrom {
  USER = 'User',
  ASSISTANT = 'Assistant',
}

export enum ActionType {
  Theme = 'Theme',
  Question = 'Question',
  Proceed = 'Proceed',
  Reject = 'Reject',
}

export interface ChatbotAction {
  id?: number;
  label: string;
  action: ActionType;
}
